<div class="row g-4 my-3">
  <div class="col-lg-4 col-md-5">
    <mat-card class="create-card shadow-sm border-0 rounded-4 overflow-hidden">
      <div class="header-bg">
        <h5 class="m-0 d-flex align-items-center">
          <mat-icon class="mr-2">add_chart</mat-icon>
          {{ 'components.custom-charts.create-new-analysis' | translate }}
        </h5>
      </div>
      <mat-card-content class="pt-4">
        <div class="mb-4">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>{{ 'components.custom-charts.chart-title' | translate }}</mat-label>
            <input matInput [(ngModel)]="newChartTitle" [placeholder]="'components.custom-charts.chart-title-placeholder' | translate">
            <mat-icon matSuffix class="text-muted">title</mat-icon>
          </mat-form-field>
        </div>

        <div class="mb-4">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>{{ 'components.custom-charts.chart-type' | translate }}</mat-label>
            <mat-select [(ngModel)]="newChartType">
              <mat-option value="bar">{{ 'components.custom-charts.type-bar' | translate }}</mat-option>
              <mat-option value="line">{{ 'components.custom-charts.type-line' | translate }}</mat-option>
              <mat-option value="pie">{{ 'components.custom-charts.type-pie' | translate }}</mat-option>
              <mat-option value="scatter">{{ 'components.custom-charts.type-scatter' | translate }}</mat-option>
            </mat-select>
            <mat-icon matSuffix class="text-muted">show_chart</mat-icon>
          </mat-form-field>
        </div>

        <div class="mb-4">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>{{ 'components.custom-charts.x-axis' | translate }}</mat-label>
            <mat-select [(ngModel)]="selectedXAxis">
              <mat-optgroup [label]="'components.custom-charts.member-custom-fields' | translate">
                @for (dim of customFieldDimensions; track dim) {
                  <mat-option [value]="dim.value">{{dim.label}}</mat-option>
                }
              </mat-optgroup>
              <mat-optgroup [label]="'components.custom-charts.survey-questions' | translate">
                @for (dim of questionDimensions; track dim) {
                  <mat-option [value]="dim.value">{{dim.label}}</mat-option>
                }
              </mat-optgroup>
            </mat-select>
            <mat-hint>{{ 'components.custom-charts.x-axis-hint' | translate }}</mat-hint>
          </mat-form-field>
        </div>

        <div class="mb-4">
          <mat-form-field appearance="outline" class="w-100 custom-field">
            <mat-label>{{ 'components.custom-charts.group-by' | translate }}</mat-label>
            <mat-select [(ngModel)]="selectedGroupBy">
              <mat-option [value]="null">{{ 'components.custom-charts.no-grouping' | translate }}</mat-option>
              <mat-optgroup [label]="'components.custom-charts.member-custom-fields' | translate">
                @for (dim of customFieldDimensions; track dim) {
                  <mat-option [value]="dim.value">{{dim.label}}</mat-option>
                }
              </mat-optgroup>
              <mat-optgroup [label]="'components.custom-charts.survey-questions' | translate">
                @for (dim of questionDimensions; track dim) {
                  <mat-option [value]="dim.value">{{dim.label}}</mat-option>
                }
              </mat-optgroup>
            </mat-select>
            <mat-hint>{{ 'components.custom-charts.group-by-hint' | translate }}</mat-hint>
          </mat-form-field>
        </div>
      </mat-card-content>
      <mat-card-actions class="px-3 pb-4 d-grid row justify-content-center">
        <button mat-flat-button color="primary" class="rounded-3 py-2"
                [disabled]="!newChartTitle || !selectedXAxis || creating"
                (click)="createNewChart()">
          @if (creating) {
            <mat-spinner diameter="20" class="mr-2 d-inline-block"></mat-spinner>
          } @else {
            <mat-icon class="mr-2">insights</mat-icon>
          }
          {{ 'components.custom-charts.generate-analysis' | translate }}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>

  <div class="col-lg-8 col-md-7">
    @if (loading) {
      <div class="d-flex flex-column align-items-center justify-content-center py-5">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="mt-3 text-muted">{{ 'components.custom-charts.loading' | translate }}</p>
      </div>
    }

    @if (!loading) {
      @for (chart of charts; track chart.id) {
        <mat-card class="chart-container mb-4 shadow-sm border-0 rounded-4 overflow-hidden">
           <div class="d-flex justify-content-between align-items-center p-3 border-bottom">
             <h6 class="m-0 fw-bold d-flex align-items-center text-dark">
               <mat-icon class="mr-2 text-primary">analytics</mat-icon>
               {{chart.title}}
             </h6>
             <button mat-icon-button (click)="deleteChart(chart.id)" [title]="'components.custom-charts.delete-analysis' | translate" class="text-danger">
               <mat-icon size="small">delete_outline</mat-icon>
             </button>
           </div>
           <mat-card-content class="p-0">
             @if (chartDataMap[chart.id]) {
                <div echarts [options]="chartDataMap[chart.id]" class="chart-content"></div>
             } @else {
                <div class="d-flex flex-column justify-content-center align-items-center chart-placeholder">
                  <mat-spinner diameter="30"></mat-spinner>
                  <span class="mt-2 text-muted small">{{ 'components.custom-charts.processing-data' | translate }}</span>
                </div>
             }
           </mat-card-content>
        </mat-card>
      }

      @if (charts.length === 0) {
        <div class="empty-state text-center py-5 px-4 bg-light rounded-4">
          <div class="icon-square shadow-sm mb-4">
            <mat-icon>query_stats</mat-icon>
          </div>
          <h4 class="fw-bold">{{ 'components.custom-charts.no-charts-title' | translate }}</h4>
          <p class="text-muted mb-4 mx-auto" style="max-width: 400px;">
            {{ 'components.custom-charts.no-charts-hint' | translate }}
          </p>
        </div>
      }
    }
  </div>
</div>
